
import React, { useState, useEffect } from "react";
import { db, auth } from "../firebaseConfig"; // Use db and auth from firebaseConfig
import { collection, addDoc, getDocs, query, where } from "firebase/firestore";
import { generatePDF } from "../utils/generatePDF"; // Importing existing PDF generation function
import UploadPDF from "./FileUpload"; // File Upload Component
import DataUpload from "./DataUpload"; // Data Upload Component
import "./VendorForm.css"; // Importing CSS for styling

const VendorForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    address: "",
    AuthorizedSignatory: "",
    gstOrPan: "",
  });

  const [vendorId, setVendorId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkIfUserFilledForm = async () => {
      const user = auth.currentUser;
      if (user) {
        try {
          const q = query(collection(db, "vendors"), where("userId", "==", user.uid));
          const querySnapshot = await getDocs(q);

          if (!querySnapshot.empty) {
            const vendorData = querySnapshot.docs[0].data();
            setVendorId(querySnapshot.docs[0].id);
            setFormData(vendorData);
          }
        } catch (error) {
          console.error("Error checking vendor form:", error);
        }
      }
      setLoading(false);
    };

    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        checkIfUserFilledForm();
      } else {
        setVendorId(null);
      }
    });

    return () => unsubscribe();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const user = auth.currentUser;
      if (!user) {
        alert("Please log in first!");
        return;
      }

      const docRef = await addDoc(collection(db, "vendors"), { 
        ...formData, 
        userId: user.uid 
      });
      
      setVendorId(docRef.id);
      alert("Form submitted successfully!");
    } catch (error) {
      console.error("Error adding document: ", error);
      alert("An error occurred while submitting the form. Please try again.");
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="vendor-container">
      {/* Vendor Form Section */}
      <div className={`vendor-form-container ${vendorId ? "vendor-form-expanded" : ""}`}>
      <h2>Vendor Registration</h2>

        {vendorId ? (
          <>
            <button onClick={() => generatePDF(formData)} className="download-button">
              📄 Download NDA
            </button>

            {/* Upload Section: File Upload & Data Upload Adjacent */}
            <div className="uploads-container">
              <div className="upload-box">
                <UploadPDF vendorId={vendorId} />
              </div>
              <div className="upload-box">
                <DataUpload />
              </div>
            </div>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            <input type="text" name="name" placeholder="Name" value={formData.name} onChange={handleChange} required />
            <input type="text" name="mobile" placeholder="Mobile No" value={formData.mobile} onChange={handleChange} required />
            <input type="text" name="address" placeholder="Address" value={formData.address} onChange={handleChange} required />
            <input type="text" name="AuthorizedSignatory" placeholder="Authorized Signatory" value={formData.AuthorizedSignatory} onChange={handleChange} required />
            <input type="text" name="gstOrPan" placeholder="GST No. / PAN" value={formData.gstOrPan} onChange={handleChange} required />
            <button type="submit">Submit</button>
          </form>
        )}
      </div>
    </div>
  );
};

export default VendorForm;
